import React from 'react';
import { View } from 'react-native-web';
import { WARNING_str } from '../../../utils/DictionaryManagementUtils';
import { LocStr } from '../../../utils/Utils';
import RegularText from './RegularText';

//= ========================================================================

const WarningMessage = ({
  children,
  language,
}) => (
  <View
    style={{
      padding: 20,
      backgroundColor: 'rgba(229, 62, 62, 0.1)',
      borderRadius: 2,
      border: 'solid 1px rgba(229, 62, 62, 0.36)',
      marginBottom: 10,
    }}
  >
    <RegularText isSemiBold>{LocStr(WARNING_str, language)}</RegularText>
    <RegularText marginBottom={0}>{children}</RegularText>
  </View>
);
export default WarningMessage;
